import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path class="st0" d="M10.83,10.37c0.24-0.6,0.47-1.18,0.7-1.76c0.04-0.11,0.09-0.19,0.22-0.17c0.14,0.02,0.14,0.13,0.14,0.24
		c-0.01,1.38-0.02,2.76-0.02,4.14c0,1.55,0.02,3.11,0.03,4.66c0,0.1,0,0.21,0,0.31c0.8,0,1.57,0,2.34,0c0-3.86,0-7.7,0-11.55
		c-1.48,0-2.94,0-4.41,0C9.7,7.49,9.35,8.68,8.85,9.83C9.52,10.01,10.16,10.19,10.83,10.37z M8.74,10.12
		c-1.78,3.61-4.49,6.21-8.27,7.69c0.04,0,0.05,0,0.07,0c2.19,0,4.38,0,6.58,0c0.09,0,0.13-0.04,0.17-0.11
		c0.4-0.79,0.82-1.58,1.21-2.37c0.63-1.28,1.24-2.57,1.86-3.85c0.13-0.27,0.24-0.55,0.36-0.82C10.04,10.47,9.39,10.29,8.74,10.12z
		 M23.55,6.23c-0.01,0-0.03,0-0.06,0c-2.15,0-4.3,0-6.45,0c-0.09,0-0.12,0.03-0.16,0.1c-0.76,1.5-1.52,2.99-2.27,4.49
		c-0.04,0.08-0.06,0.17-0.06,0.26c0,1.64,0,3.29,0,4.93c0,0.05,0,0.09,0,0.11C16,11.42,18.99,8.12,23.55,6.23z"/>
	<path d="M10.83,10.37c-0.67-0.18-1.32-0.36-1.98-0.53C9.35,8.68,9.7,7.49,9.83,6.24c1.47,0,2.93,0,4.41,0c0,3.85,0,7.69,0,11.55
		c-0.77,0-1.54,0-2.34,0c0-0.11,0-0.21,0-0.31c-0.01-1.55-0.03-3.11-0.03-4.66c0-1.38,0.01-2.76,0.02-4.14c0-0.11,0-0.22-0.14-0.24
		c-0.13-0.02-0.18,0.06-0.22,0.17C11.3,9.19,11.07,9.77,10.83,10.37z"/>
	<path d="M8.74,10.12c0.65,0.17,1.3,0.35,1.97,0.53c-0.12,0.28-0.23,0.56-0.36,0.82c-0.62,1.29-1.23,2.57-1.86,3.85
		c-0.39,0.8-0.81,1.58-1.21,2.37c-0.04,0.08-0.08,0.11-0.17,0.11c-2.19,0-4.38,0-6.58,0c-0.01,0-0.03,0-0.07,0
		C4.25,16.33,6.96,13.73,8.74,10.12z"/>
	<path d="M23.55,6.23c-4.55,1.89-7.55,5.19-9,9.89c0-0.02,0-0.07,0-0.11c0-1.64,0-3.29,0-4.93c0-0.09,0.02-0.18,0.06-0.26
		c0.76-1.5,1.52-2.99,2.27-4.49c0.04-0.07,0.07-0.1,0.16-0.1c2.15,0,4.3,0,6.45,0C23.51,6.23,23.54,6.23,23.55,6.23z"/>
</g>    </svg>
    </SvgIcon>
  )
}
